const release = ""
const apiClientBaseURL = "/api/"

// TODO:
const originURL = ""
const cryptchaSiteId = "6628f06a0938460001505119"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}
/**
 *
 * @param {User} user
 */
function getAllowedTaskTypes(user) {
    let taskTypes = []
    if (user.roles.includes("admin")) {
        taskTypes = ["oilSpillRemoval", "towing"]
    } else if (user.additionalPermissions.includes("editTowingOrders")) {
        taskTypes.push("towing")
    } else if (user.additionalPermissions.includes("editOilSpillOrders")) {
        taskTypes.push("oilSpillRemoval")
    }
    return taskTypes
}

module.exports = {
    release,
    apiClientBaseURL,
    frontendBase: "https://wohner.app/",
    tibiUrl: "https://wohner-tibiadmin.code.testversion.online/",
    wohnerApiUrl: "https://wohner.app/api/",
    tibiServerUrl: "https://wohner.app/api/",
    originURL,
    cryptchaSiteId,
    getAllowedTaskTypes,
}
